import React from "react";
import { MDBRow } from 'mdb-react-ui-kit';

export default function SoloInfoAgg({
    setInfoAggiuntive, 
    }) {

	return (
		<>
            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>
            </>
	);
}